/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MonthlyProjectionNotificationRequest } from '../models/MonthlyProjectionNotificationRequest';
import type { Page_AdminProjectionCommentResponse_ } from '../models/Page_AdminProjectionCommentResponse_';
import type { ProjectionCommentDto } from '../models/ProjectionCommentDto';
import type { ProjectionCommentRequest } from '../models/ProjectionCommentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProjectionCommentRestControllerService {
  /**
   * getComments
   * @returns ProjectionCommentDto OK
   * @throws ApiError
   */
  public static getCommentsUsingGet({
    month,
    studentId,
    subjectId,
    year,
  }: {
    /**
     * month
     */
    month:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * studentId
     */
    studentId: string;
    /**
     * subjectId
     */
    subjectId: string;
    /**
     * year
     */
    year: number;
  }): CancelablePromise<ProjectionCommentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/projection-comments',
      query: {
        month: month,
        studentId: studentId,
        subjectId: subjectId,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * saveOrUpdateComments
   * @returns ProjectionCommentDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static saveOrUpdateCommentsUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: ProjectionCommentRequest;
  }): CancelablePromise<ProjectionCommentDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/projection-comments',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAdminViewCommentStatus
   * @returns Page_AdminProjectionCommentResponse_ OK
   * @throws ApiError
   */
  public static getAdminViewCommentStatusUsingGet({
    armId,
    classLevelId,
    month,
    subjectId,
    year,
    limit,
    offset,
    search,
  }: {
    /**
     * armId
     */
    armId: string;
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * month
     */
    month:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * subjectId
     */
    subjectId: string;
    /**
     * year
     */
    year: number;
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_AdminProjectionCommentResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/projection-comments/admin-view/{classLevelId}/{armId}/{subjectId}',
      path: {
        armId: armId,
        classLevelId: classLevelId,
        subjectId: subjectId,
      },
      query: {
        limit: limit,
        month: month,
        offset: offset,
        search: search,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * sendNotification
   * @returns any OK
   * @throws ApiError
   */
  public static sendNotificationUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: MonthlyProjectionNotificationRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/projection-comments/notification',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
